import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Agent, AuthProject, Organization, Role, User, UserRole } from '../core/auth/models/user';
import { Criteria } from '../core/models/criteria-dto';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  private readonly api: string;

  constructor(private http: HttpClient) {
    this.api = `${environment.genaiApiUrl}`;
  }

  getClients(): Observable<Organization[]>{
    return this.http.get<Organization[]>(`${this.api}/admin/organizations`);
  }

  saveClient(organization: Organization): Observable<Organization>{
    return this.http.post<Organization>(`${this.api}/admin/organization`, organization);
  }

  updateClient(organization: Organization): Observable<Organization>{
    return this.http.put<Organization>(`${this.api}/admin/organization`, organization);
  }

  deleteClient(organizationId: string) {
    return this.http.delete(`${this.api}/admin/organization/${organizationId}`);
  }

  getUsers(organizationId: string): Observable<User[]> {
    return this.http.get<User[]>(`${this.api}/admin/organization/${organizationId}/users`);
  }

  deleteUser(userId: string, selectedOrganizationId: string) {
    return this.http.delete(`${this.api}/admin/user/${userId}/${selectedOrganizationId}`);
  }

  saveUser(user: User, selectedOrganizationId: string): Observable<User>{
    return this.http.post<User>(`${this.api}/admin/user`, {user:user,organizationId:selectedOrganizationId});
  }

  updateUser(user: User): Observable<User>{
    return this.http.put<User>(`${this.api}/admin/user`, user);
  }

  getProjects(organizationId: string): Observable<AuthProject[]> {
    return this.http.get<AuthProject[]>(`${this.api}/admin/organization/${organizationId}/projects`);
  }

  deleteProject(projectId: string) {
    return this.http.delete(`${this.api}/admin/project/${projectId}`);
  }

  saveProject(project: AuthProject, organizationId: string): Observable<AuthProject> {
    return this.http.post<AuthProject>(`${this.api}/admin/organization/${organizationId}/project`, project);
  }

  updateProject(project: AuthProject, organizationId: string): Observable<AuthProject> {
    return this.http.put<AuthProject>(`${this.api}/admin/organization/${organizationId}/project`, project);
  }

  getAgents(): Observable<Agent[]>{
    return this.http.get<Agent[]>(`${this.api}/admin/agents`);
  }

  saveAgentsForProject(projectId: string, agents: Agent[]): Observable<any> {
    return this.http.post<any>(`${this.api}/admin/project/${projectId}/agents`, agents);
  }

  updateAgentsForProject(projectId: string, agents: Agent[]): Observable<any> {
    return this.http.put<any>(`${this.api}/admin/project/${projectId}/agents`, agents);
  }

  getEnabledAgentsForProject(projectId: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.api}/admin/project/${projectId}/agents-enabled`);
  }
  getRolesByProject(projectId: string): Observable<Role[]> {
    return this.http.get<Role[]>(`${this.api}/admin/project/${projectId}/roles`);
  }

  saveRoleForUser(userId: string, roleId: string): Observable<UserRole> {
    return this.http.post<UserRole>(`${this.api}/admin/user/${userId}/role`, {roleId: roleId, userId: userId});
  }

  removeRoleForUser(userId: string, roleId: string): Observable<any> {
    return this.http.delete<any>(`${this.api}/admin/user/${userId}/role/${roleId}`);
  }

  getRolesByUser(userId: string): Observable<Role[]>{
    return this.http.get<Role[]>(`${this.api}/admin/user/${userId}/roles`);
  }

  getCriteria(): Observable<Criteria[]>{
    return this.http.get<Criteria[]>(`${this.api}/criteria`);
  }
  updateOrganizationAdmin(userId: string, selectedOrganizationId: string, isAdmin: boolean): Observable<boolean>{
    return this.http.post<boolean>(`${this.api}/admin/user-organization/user/${userId}/organization/${selectedOrganizationId}/admin`,isAdmin);
  }

  getUserOrganizationsByEmail(email: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.api}/admin/user/organizations`, {
      params: { email }
    });
  }
}
